import { useEffect, useRef } from "react";
import { useEnv } from "../chat/utils";
import "./livechat.style.css";

export default function GenesysChat() {
  const scriptLoaded = useRef(false);
  const { isValid, values, error } = useEnv(["GENESYS_LIVECHAT_ENVIRONMENT", "GENESYS_LIVECHAT_DEPLOYMENT_ID"]);

  const environment = values.GENESYS_LIVECHAT_ENVIRONMENT;
  const deploymentId = values.GENESYS_LIVECHAT_DEPLOYMENT_ID;

  useEffect(() => {
    if (scriptLoaded.current) return;

    try {
      window["_genesysJs"] = "Genesys";
      window["Genesys"] =
        window["Genesys"] ||
        function () {
          (window["Genesys"].q = window["Genesys"].q || []).push(arguments);
        };
      window["Genesys"].t = Date.now();
      window["Genesys"].c = { environment: environment, deploymentId: deploymentId };

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.charset = "utf-8";
      script.src = "https://apps.mypurecloud.jp/genesys-bootstrap/genesys.min.js";
      script.onerror = () => {
        console.error("Failed to load Genesys script");
      };

      document.head.appendChild(script);
      scriptLoaded.current = true;
    } catch (error) {
      console.error("Error loading Genesys script:", error);
    }
  }, [environment, deploymentId]);

  if (!isValid) {
    console.error("LiveChat configuration is invalid:", error);
    return null;
  }

  return null;
}
